import React, { useState, useEffect } from 'react';
import { getGitMetricsFromDB } from '../../services/apiServices';
import Container from 'react-bootstrap/Container';
import GitMetricsAgGrid from './GitMetricsAgGrid';
import SearchForm from '../common/SearchForm';
import { Modal, Row, Spinner } from 'react-bootstrap';
import DeveloperBarChart from '../Reports/developer-distribution/bar/DeveloperBarChart';
import DualPieChartDisplay from '../Reports/developer-distribution/pie/DualPieChartDisplay';

const HomePage = () => {
    const today = new Date();
    today.setHours(23, 59, 59, 999);
    const currDay = today.toISOString(); // endDate
  
    // subtract one month
    const lastMonthDate = new Date(today);
    lastMonthDate.setMonth(lastMonthDate.getMonth() - 1);
  
    const firstDay = lastMonthDate.toISOString().split('T')[0];

    const [startDate, setStartDate] = useState(firstDay);   
    const [endDate, setEndDate] = useState(currDay);
    const [showModal, setShowModal] = useState(false);
    const [gitMetricsData, setGitMetricsData] = useState([]);
    const [formData, setFormData] = useState(null);

    useEffect(() => {
        const getGitMetricsData = async () => {
            setShowModal(true); // Show the spinner while loading
            try {
                const loggedInUserDetails = JSON.parse(localStorage.getItem('loggedInUserDetails'));
                let gitMetrics = await getGitMetricsFromDB({
                    platform: formData.platform,
                    selectedRepositoryId: formData.selectedRepositoryId,
                    selectedRepositoryNames: formData.selectedRepositoryNames,
                    selectedDeveloperNames: formData.selectedDeveloperNames,
                    startDate: formData.startDate,
                    endDate: formData.endDate, 
                    loggedInUser : loggedInUserDetails?.Name,
                    loggedInUserDetails :loggedInUserDetails
                });
                setGitMetricsData(gitMetrics.commitsByDevelopers);
            } catch (error) {
                console.error("Error fetching data:", error);
            } finally {
                setShowModal(false); //  Hide the spinner only after data is ready or error occurs
            }
        }
        if (
            formData &&
            formData.selectedDeveloperNames.length > 0 &&
            formData.selectedRepositoryId.length > 0
        ) {
            getGitMetricsData();
        }
    }, [formData]);

    const handleCloseModal = () => {
        setShowModal(false);
    }

    return (
        <>
            <Container fluid>
                <SearchForm
                    setFormData={setFormData}
                    setShowModal={setShowModal}
                    startDate={startDate}
                    setStartDate={setStartDate}
                    endDate={endDate}
                    setEndDate={setEndDate}
                />
                <Row className='table-container'>
                    <GitMetricsAgGrid
                        startDate={startDate}
                        endDate={endDate}
                        gitMetricsGrid={gitMetricsData}
                        platform={formData?.platform || "AzureDevOps"}
                    />
                </Row>
                <Row style={{ paddingInline: 12 , paddingBottom: 20}}>
                    <DeveloperBarChart
                        data={gitMetricsData}
                    />
                    <DualPieChartDisplay
                        data={gitMetricsData}
                    />

                </Row>
            </Container>
            <Modal show={showModal} onHide={handleCloseModal} centered>
                <Modal.Body className='modal-body-wrapper'><Spinner animation="border" variant="warning" /></Modal.Body>
            </Modal>
        </>
    );
};

export default HomePage;